"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationMethod = void 0;
var CommonEvaluationMethods;
(function (CommonEvaluationMethods) {
    CommonEvaluationMethods["sum"] = "sum";
    CommonEvaluationMethods["avg"] = "avg";
    CommonEvaluationMethods["min"] = "min";
    CommonEvaluationMethods["max"] = "max";
    CommonEvaluationMethods["percentile"] = "percentile";
    CommonEvaluationMethods["p99"] = "p99";
})(CommonEvaluationMethods || (CommonEvaluationMethods = {}));
exports.EvaluationMethod = { ...CommonEvaluationMethods };
//# sourceMappingURL=evaluationMethod.js.map